import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Balance_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Balance_Report() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedAcademic, setSelectedAcademic] = useState("cay25");
  const [searchTerm, setSearchTerm] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        academic: selectedAcademic,
        search: searchTerm,
        page: 1,
        limit: 10,
      };

      const response = await simplePostCall(
        ApiConfig.termwiseRports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setReportData(response.data || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  }, [selectedAcademic, searchTerm]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchInitialData();
  };

  return (
    <div className="balance_data_report-container fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Balance Report</h4>
        <button className="btn btn-sm btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <form onSubmit={handleSearch} className="yc-list-filter">
          <input
            type="text"
            className="form-control"
            placeholder="Search Student..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className="form-select"
            value={selectedAcademic}
            onChange={(e) => setSelectedAcademic(e.target.value)}
          >
            <option value="cay25">2024-2025</option>
            <option value="cay24">2023-2024</option>
          </select>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </form>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Adm. No</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Class/Sec</div>
            <div className="yc-list-cell">Total Invoiced</div>
            <div className="yc-list-cell">Paid</div>
            <div className="yc-list-cell">Balance</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : reportData.length > 0 ? (
          <div className="yc-list-row-list">
            {reportData.map((item, index) => (
              <div key={item.student_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-7">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{item.student_admission_num}</div>
                  <div className="yc-list-cell">{item.student_name}</div>
                  <div className="yc-list-cell">
                    {item.class_name} - {item.section_name}
                  </div>
                  <div className="yc-list-cell">
                    {customer_currency} {formatNumber(item.total_invoiced)}
                  </div>
                  <div className="yc-list-cell">
                    {customer_currency} {formatNumber(item.total_paid)}
                  </div>
                  <div className="yc-list-cell yc-amount-danger">
                    {customer_currency} {formatNumber(item.balance)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No records found.</div>
        )}
      </div>
    </div>
  );
}

export default Balance_Report;
